import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function TopNavBar({ onExport, isExporting }) {
  const location = useLocation();

  const isProjects = location.pathname === '/';
  
  return (
    <header className="bg-surface dark:bg-surface-container-low flex justify-between items-center w-full px-gutter h-16 border-b border-outline-variant dark:border-white/10 shrink-0 z-50 relative shadow-sm">
      <div className="flex items-center gap-6 h-full">
        <h1 className="font-headline-h2 text-headline-h2 font-bold text-on-surface tracking-tight">LAMB Lyric Video Creator</h1>
        
        <nav className="hidden md:flex items-center gap-1 h-full ml-4">
          <Link 
            to="/" 
            className={`font-body-md text-body-md h-16 px-4 flex items-center transition-colors duration-200 ${
              isProjects 
                ? 'text-primary border-b-2 border-primary opacity-80' 
                : 'text-on-surface-variant hover:text-on-surface hover:bg-surface-variant'
            }`}
          >
            Projects
          </Link>
          <a 
            href="#" 
            className="font-body-md text-body-md h-16 px-4 flex items-center text-on-surface-variant hover:text-on-surface hover:bg-surface-variant transition-colors"
          >
            Assets
          </a>
          <a 
            href="#" 
            className="font-body-md text-body-md h-16 px-4 flex items-center text-on-surface-variant hover:text-on-surface hover:bg-surface-variant transition-colors"
          >
            History
          </a>
        </nav>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1 mr-2">
          <button className="p-2 rounded-full text-on-surface-variant hover:text-on-surface hover:bg-surface-variant transition-colors">
            <span className="material-symbols-outlined text-[20px]">notifications</span>
          </button>
          <button className="p-2 rounded-full text-on-surface-variant hover:text-on-surface hover:bg-surface-variant transition-colors">
            <span className="material-symbols-outlined text-[20px]">settings</span>
          </button>
        </div>
        
        {!isProjects && (
          <button 
            onClick={onExport}
            disabled={isExporting}
            className="bg-primary-container text-white px-4 py-2 rounded-md font-label-md text-label-md hover:bg-inverse-primary transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span className="material-symbols-outlined text-[18px]">ios_share</span> 
            {isExporting ? 'Exporting...' : 'Export'}
          </button>
        )}
        
        <div className="w-8 h-8 rounded-full bg-surface-container-highest border border-outline-variant ml-2 overflow-hidden cursor-pointer">
          <img 
            alt="User Avatar" 
            className="w-full h-full object-cover" 
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuAc7eJ2ee4_LZWEd201ptvlOsGLA9ZXZ1DPbcCqOJSwCzdG2AEq2P04WA2ZXU_x-gvN7hQypH3vZS8rEjUclVz07ZlymRM7HfGhEUboRVdEjV1nImfFByuewDnoSlBZ60UEYiXgeJNbqGizEt8Ort4aaAVFlNQeLNucZ0g4Q28FlACmyzIjtpND9eKAq-MCOyLU-ed5sCiLpkj4m1dvgU6NHXeQeVPWSjOTySyJHgzO4lHJe9_akwAAJFKxD_U5YOvXw27HCCvUIypz"
          />
        </div>
      </div>
    </header>
  );
}
